export const FilledIcon = ({ width, height }: { width: number; height: number }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 53 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.0862 22.9138L43.0953 22.9059L43.0137 22.8987L43.0862 22.9138ZM14.5484 32.159L10.2828 50.5996L26.4922 40.8215L42.7016 50.5996L38.4359 32.159L52.7422 19.7559L33.8422 18.1152L26.4922 0.724609L19.1422 18.1152L0.242188 19.7559L14.5484 32.159Z"
      fill="#E2B640"
    />
  </svg>
);
